import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { PageHeader } from "../../components/StaffLayout";
import StatCard from "../../components/StatCard";
import { Calendar, Stethoscope, Tooth, Users, ArrowRight } from "@phosphor-icons/react";

export default function DoctorDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/doctor/dashboard").then((r) => setData(r.data)); }, []);

  if (!data) return <div className="p-12 text-sm text-zinc-500">Loading...</div>;
  const d = data.doctor;

  return (
    <div data-testid="doctor-dashboard">
      <PageHeader title={`Welcome, ${d.name}`} subtitle={d.specialization || "Doctor console"}/>
      <div className="px-6 sm:px-10 py-8 space-y-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <StatCard label="My Patients" value={data.my_patients} sub="Assigned to you"/>
          <StatCard label="Today" value={data.today_appointments} sub="Appointments today" accent={data.today_appointments>0}/>
          <StatCard label="Next 7 days" value={data.week_appointments} sub="Coming up"/>
          <StatCard label="Treatments" value={data.completed_treatments} sub="Performed by you"/>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div className="bg-white border border-zinc-200 rounded-sm">
            <div className="px-5 py-4 border-b border-zinc-200 flex items-center justify-between">
              <h3 className="font-bold tracking-tight" style={{fontFamily:"Manrope, sans-serif"}}>Upcoming appointments</h3>
              <Link to="/staff/calendar" className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-700 hover:text-[#E60000] inline-flex items-center gap-1">
                Calendar <ArrowRight size={12} weight="bold"/>
              </Link>
            </div>
            <div className="divide-y divide-zinc-100">
              {(data.upcoming_appointments || []).length === 0 && <div className="p-6 text-sm text-zinc-500">No upcoming appointments.</div>}
              {(data.upcoming_appointments || []).map((a) => (
                <div key={a.id} className="px-5 py-3 flex items-center gap-3" data-testid={`dd-appt-${a.id}`}>
                  <Calendar size={16} weight="duotone" color="#E60000"/>
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold text-zinc-900">{a.patient?.name || "â€”"}</div>
                    <div className="text-xs text-zinc-500">{new Date(a.starts_at).toLocaleString()} Â· {a.treatment || "Consultation"}</div>
                  </div>
                  <Link to={`/staff/patients/${a.patient_id}`} className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-700 hover:text-[#E60000]">Open â€º</Link>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white border border-zinc-200 rounded-sm">
            <div className="px-5 py-4 border-b border-zinc-200 flex items-center justify-between">
              <h3 className="font-bold tracking-tight" style={{fontFamily:"Manrope, sans-serif"}}>Recent treatments</h3>
              <Stethoscope size={16} weight="duotone" color="#E60000"/>
            </div>
            <div className="divide-y divide-zinc-100">
              {(data.recent_treatments || []).length === 0 && <div className="p-6 text-sm text-zinc-500">No recent treatments.</div>}
              {(data.recent_treatments || []).map((t) => (
                <div key={t.id} className="px-5 py-3 flex items-start gap-3">
                  <Tooth size={16} weight="duotone" color="#E60000" className="mt-0.5"/>
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold text-zinc-900">{t.title}</div>
                    <div className="text-xs text-zinc-500">{t.patient?.name} Â· {t.performed_at?.slice(0,10)}</div>
                  </div>
                  {t.cost ? <span className="text-xs font-bold text-zinc-700">â‚¹{t.cost}</span> : null}
                </div>
              ))}
            </div>
          </div>
        </div>

        <Link to="/staff/patients" className="inline-flex items-center gap-2 bg-zinc-900 text-white hover:bg-zinc-800 font-semibold rounded-sm px-5 py-3 text-sm">
          <Users size={16} weight="bold"/> View my patients <ArrowRight size={14} weight="bold"/>
        </Link>
      </div>
    </div>
  );
}
